import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor (private authService:AuthService, private router:Router){

  }

  canActivate() {
    if(this.authService.loggedIn() || localStorage.getItem('searchWithoutLogin') == 'true') {
      console.log("auth guard check__________--", localStorage.getItem('searchWithoutLogin'))
      return true;
    } else {
      this.router.navigate(['/landing']);
      return false;
    }
  }
}
